import type { FC } from 'react';
import type { StudentOpportunity } from '../types';

interface StudentOpportunitiesOverlayProps {
  opportunities: StudentOpportunity[];
  onToggleTracking: (id: string, currentTracked: boolean) => void;
  onBackToCabinet: () => void;
}

export const StudentOpportunitiesOverlay: FC<StudentOpportunitiesOverlayProps> = ({
  opportunities,
  onToggleTracking,
  onBackToCabinet,
}) => {
  return (
    <div className="space-y-6 pb-12">
      <div className="border border-slate-800 bg-[#081321] rounded-2xl p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-xl">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onBackToCabinet}
            className="w-10 h-10 rounded-xl bg-slate-900 border border-slate-700/80 hover:border-cyan-400 text-slate-300 hover:text-cyan-400 flex items-center justify-center transition-all"
            aria-label="Вернуться в кабинет"
          >
            &larr;
          </button>
          <div>
            <p className="text-[11px] uppercase tracking-wider text-cyan-400 font-semibold">
              Кабинет обучающегося
            </p>
            <h2 className="text-xl font-bold text-white tracking-wide">Возможности и развитие</h2>
            <p className="text-xs text-slate-400">
              Конференции · семинары · публикации · мобильность · стажировки · школы · конкурсы.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onBackToCabinet}
          className="px-5 py-2 rounded-xl bg-[#E5A83B] hover:bg-[#D4982E] text-slate-950 text-xs font-bold transition-all shadow-md self-end sm:self-auto"
        >
          Сохранить
        </button>
      </div>

      <div className="p-5 rounded-2xl bg-[#081524] border border-amber-500/40 space-y-1">
        <p className="text-[10px] uppercase tracking-wider text-amber-400 font-bold">
          ВОЗМОЖНОСТИ И РАЗВИТИЕ
        </p>
        <h3 className="text-xl font-bold text-white">
          Конференции, публикации и академическое развитие
        </h3>
        <p className="text-xs text-slate-400">
          Здесь фиксируются возможности вне обязательного учебного процесса: участие, дедлайны, документы и личный статус.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {opportunities.map((opp) => (
          <div
            key={opp.id}
            className="p-5 rounded-2xl bg-[#081321] border border-slate-800 hover:border-cyan-500/40 transition-all space-y-4 flex flex-col justify-between"
          >
            <div>
              <span className="text-[10px] font-bold text-cyan-400 uppercase tracking-wider">
                {opp.category}
              </span>
              <h4 className="text-base font-bold text-white mt-1">{opp.title}</h4>
              <p className="text-xs text-slate-400 mt-1 leading-relaxed">{opp.description}</p>
              <div className="flex flex-wrap gap-2 mt-3">
                <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-cyan-950 text-cyan-300 border border-cyan-800/60">
                  {opp.status_label}
                </span>
                {opp.deadline && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-mono font-medium bg-slate-800 text-amber-300 border border-slate-700">
                    Дедлайн {opp.deadline}
                  </span>
                )}
              </div>
            </div>

            <div className="pt-3 border-t border-slate-800">
              <button
                type="button"
                onClick={() => onToggleTracking(opp.id, opp.is_tracked)}
                className={`w-full py-2 rounded-xl text-xs font-bold transition-all border ${
                  opp.is_tracked
                    ? 'bg-slate-900 border-slate-700 hover:border-slate-500 text-slate-200'
                    : 'bg-amber-950/60 border-amber-600/50 hover:bg-amber-900 text-amber-300'
                }`}
              >
                Сохранить / отслеживать
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
